import { provideRouter, Routes, withInMemoryScrolling } from '@angular/router';
import {
  APP_ID,
  ApplicationConfig,
  ErrorHandler,
  importProvidersFrom,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SsWebSocketsModule } from './core/vendor/ss-web-sockets/ss-web-sockets.module';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import {
  EVENT_MANAGER_PLUGINS,
  provideClientHydration,
  withEventReplay,
  withIncrementalHydration,
} from '@angular/platform-browser';
import { ContentUpdaterService } from './core/services/content-updater/content-updater.service';
import { CookieService } from 'ngx-unificator/services';
import { HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { GlobalErrorHandler } from './core/helpers/global-error-handler';
import { CacheControlInterceptor } from './core/interceptors/cache-control.interceptor';
import { HostRequestsInterceptor } from './core/interceptors/host-requests.interceptor';
import { provideAnimations } from '@angular/platform-browser/animations';
import { abTestList } from './core/ab-test/ab-test.data';
import { provideABTest } from './core/ab-test/ab-test';
import { GlobalStore } from './core/store';
import { provideStoreInitializer } from 'ngx-unificator/store';
import { provideInitializer } from './core/initializer/initializer.queue';
import { DecimalPipe } from '@angular/common';
import { provideBrandConfig } from './core/services/brand-config/brand-config.provider';
import { HammerEventsPlugin } from './core/helpers/hammer.manager';
import { provideBotRules } from './core/providers/bot-rules.provider';

const routes: Routes = [
  {
    path: '',
    children: [
      { path: '', loadChildren: () => import('./page/page.module').then(m => m.PageModule) },
    ],
  },
];

export const appConfig: ApplicationConfig = {
  providers: [
    provideStoreInitializer(GlobalStore),
    provideInitializer(),
    provideHttpClient(withInterceptorsFromDi(), withFetch()),
    provideBrandConfig(),
    provideABTest(abTestList),
    provideBotRules(),
    provideClientHydration(
      withIncrementalHydration(),
      withEventReplay(),
    ),
    provideZonelessChangeDetection(),
    provideBrowserGlobalErrorListeners(),
    provideRouter(
      routes,
      withInMemoryScrolling(
        { scrollPositionRestoration: 'enabled', anchorScrolling: 'enabled' },
      ),
    ),
    importProvidersFrom(
      FormsModule,
      ReactiveFormsModule,
      SsWebSocketsModule,
      NgxMaskDirective,
    ),
    ContentUpdaterService,
    CookieService,
    DecimalPipe,
    provideNgxMask(),
    provideAnimations(),
    { provide: APP_ID, useValue: '21bit' },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    { provide: EVENT_MANAGER_PLUGINS, useClass: HammerEventsPlugin, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CacheControlInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HostRequestsInterceptor,
      multi: true,
    },
  ],
};
